module.exports = __webpack_public_path__ + "media/images/hero_header/hero_header1-0504e6d66109ea70d103fdf6a305f129.jpeg";